








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { User } from '@/interfaces/user.interface';
import UserEdit from '@/components/UserEdit.vue';
import {namespace} from "vuex-class";
import { VuetifyPaginationInterface } from '@/interfaces/vuetify-pagination.interface';

const usersModule = namespace('users');

@Component({
  components: {
    UserEdit
  }
})
export default class UserTable extends Vue {
  @Prop({default: []}) users!: User[];
  @usersModule.Action deleteWithConfirmation: any;
  @usersModule.Action setPagination: any;

  pagination: VuetifyPaginationInterface = this.$store.state.users.pagination;
  expanded: any = [];

  @Watch('pagination', {immediate: true, deep: true})
  async paginationWatcher() {
    this.setPagination({pagination: this.pagination});
  }

  get search(): string {
    return this.$store.state.users.userFilters.search;
  }

  get headers() {
    return [
      {text: 'Email', value: 'email'},
      {text: 'Name', value: 'firstName'},
      {text: 'Phone number', value: 'phoneNumber'},
      {text: 'Last login', value: 'last_login'},
      {text: 'Role', value: 'roleName'},
      {text: 'Group', value: 'groupName'},
      {text: 'Last Name', value: 'lastName', class: 'hidden'}
    ];
  }

  get paginationItems(): any[] {
    return [5, 10, 25, { text: "All", value: -1 }];
  }

  async deleteUser(user: User): Promise<any> {
    return await this.deleteWithConfirmation({user});
  }
}
